import { render, staticRenderFns } from "./WillBeneficiairiesManagingFinancesYN.vue?vue&type=template&id=340dcbde"
import script from "./WillBeneficiairiesManagingFinancesYN.vue?vue&type=script&lang=js"
export * from "./WillBeneficiairiesManagingFinancesYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports